export default __webpack_public_path__ + "static/4-0a643d6f7f03167c15efa72b7fa0f405.jpg";